'use client';

import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { SUBSCRIPTION, type Subscription } from '@/common/enums';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { Button } from '@/frontend/design-system/actions/Button';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { MentoringCard } from '../../_components/MentoringCard';
import { SubscriptionTabs } from '../../_components/SubscriptionTabs';
import { BuyData } from '../../BuyData';
import { ScheduleAppointmentDialog } from '../../ScheduleAppointmentDialog';
import { AdvancedMentoringManager } from '../AdvancedMentoringManager';
import { useUpdateMentoringProductOnTabChange } from '../AdvancedMentoringManager/_hooks/updateMentoringProductOnTabChange';
import { useInitMentoringProductWithMentoringDetailsData } from '../AdvancedMentoringManager/_hooks/useInitMentoringProductWithMentoringDetailsData';
type AdvancedMentoringProps = {
  activeSubscriptionTab: Subscription;
  setActiveSubscriptionTab: Dispatch<SetStateAction<Subscription>>;
};
export function AdvancedMentoring(t0) {
  const $ = _c(31);
  const {
    activeSubscriptionTab,
    setActiveSubscriptionTab
  } = t0;
  const [isScheduleAppointmentDialogOpen, setIsScheduleAppointmentDialogOpen] = useState(false);
  let t1;
  if ($[0] !== activeSubscriptionTab) {
    t1 = {
      activeSubscriptionTab
    };
    $[0] = activeSubscriptionTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [advancedMentoringProduct, setAdvancedMentoringProduct] = useInitMentoringProductWithMentoringDetailsData(t1);
  let t2;
  if ($[2] !== activeSubscriptionTab || $[3] !== advancedMentoringProduct || $[4] !== setAdvancedMentoringProduct) {
    t2 = {
      mentoringProduct: advancedMentoringProduct,
      subscription: activeSubscriptionTab,
      setMentoringProduct: setAdvancedMentoringProduct
    };
    $[2] = activeSubscriptionTab;
    $[3] = advancedMentoringProduct;
    $[4] = setAdvancedMentoringProduct;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useUpdateMentoringProductOnTabChange(t2);
  const isMobile = useMediaQuery("(max-width: 1023px)");
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <P3>Wszystko co w mentoringu podstawowym + dodatkowe opcje dostosowane do Twoich potrzeb. Zawiera nielimitowany dostęp do wszystkich kursów grupowych AlgoAcademy oraz indywidualną opiekę mentora. Możesz dodatkowo dostosować:</P3>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeSubscriptionTab || $[8] !== advancedMentoringProduct || $[9] !== setAdvancedMentoringProduct) {
    t4 = <AdvancedMentoringManager activeSubscriptionTab={activeSubscriptionTab} advancedMentoringProduct={advancedMentoringProduct} setAdvancedMentoringProduct={setAdvancedMentoringProduct} />;
    $[7] = activeSubscriptionTab;
    $[8] = advancedMentoringProduct;
    $[9] = setAdvancedMentoringProduct;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== activeSubscriptionTab || $[12] !== isMobile || $[13] !== setActiveSubscriptionTab) {
    t5 = isMobile && <div className="flex flex-col items-center"><P3 className="text-slate-900">Typ subskrypcji</P3><div className="h-3 w-full" /><SubscriptionTabs tabs={Object.values(SUBSCRIPTION) as Subscription[]} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} /></div>;
    $[11] = activeSubscriptionTab;
    $[12] = isMobile;
    $[13] = setActiveSubscriptionTab;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="space-y-8">{t3}{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider className="my-4" />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== advancedMentoringProduct) {
    t8 = <BuyData mentoringProduct={advancedMentoringProduct} />;
    $[19] = advancedMentoringProduct;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <VerticalSpacer size="content" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col items-center gap-3"><Button size="xl" className="w-full lg:w-fit" onClick={() => setIsScheduleAppointmentDialogOpen(true)}>Umów bezpłatne spotkanie</Button><Button plain={true} size="xl" className="w-full lg:w-fit" href="/regulamin">Szczegóły subskrypcji</Button></div>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsScheduleAppointmentDialogOpen(false);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== advancedMentoringProduct || $[25] !== isScheduleAppointmentDialogOpen) {
    t12 = <ScheduleAppointmentDialog mentoringProduct={advancedMentoringProduct} isOpen={isScheduleAppointmentDialogOpen} onClose={t11} />;
    $[24] = advancedMentoringProduct;
    $[25] = isScheduleAppointmentDialogOpen;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t6 || $[29] !== t8) {
    t13 = <MentoringCard title="Mentoring spersonalizowany">{t6}{t7}{t8}{t9}{t10}{t12}</MentoringCard>;
    $[27] = t12;
    $[28] = t6;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}